module.exports = __webpack_public_path__ + "static/media/Retreats-01.2e32368a.webp";